import React from "react";
import { useParams, Navigate } from "react-router-dom";

import ProposalPublicPage from "./ProposalPublicPage";

/**
 * Root-level public proposal route: proposals.collings.com.au/<token>.
 * Only a real-looking share token (32 hex) renders the proposal; any other
 * single-segment path falls through to the app home, so this can't shadow
 * normal routes. `/proposal/<token>` still works as an alias.
 */
const ProposalTokenRoute = () => {
  const { token } = useParams();
  if (!token || !/^[0-9a-f]{32}$/i.test(token)) return <Navigate to="/" replace />;
  return <ProposalPublicPage />;
};

export default ProposalTokenRoute;
